import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import useCustomDropzone from 'hooks/useCustomDropzone';
import type { FC } from 'react';
import { useState } from 'react';
import type { DropzoneProps } from './Dropzone.types';

const theme: { [key: string]: { [key: string]: string } } = {
  transparent: {
    base: 'bg-transparent',
    interactive: 'hover:bg-transparent',
  },
  expenses: {
    base: 'bg-expenses-100 dropzone-border-expenses',
    interactive: 'hover:bg-expenses-50',
  },
  taxes: {
    base: 'bg-taxes-100 dropzone-border-taxes',
    interactive: 'hover:bg-taxes-50',
  },
  revenues: {
    base: 'bg-revenues-100 dropzone-border-revenues',
    interactive: 'hover:bg-revenues-50',
  },
  bank: {
    base: 'bg-bank-100 dropzone-border-bank',
    interactive: 'hover:bg-bank-50',
  },
  basic: {
    base: 'bg-transparent border-0',
    interactive: 'hover:bg-transparent',
  },
};

const Dropzone: FC<DropzoneProps> = ({
  dropOptions,
  render,
  className,
  color,
  renderWrapperClassName,
  asDefault,
  onClick,
}): JSX.Element => {
  const worldColor = useWorldTheme();

  const { getRootProps, getInputProps, ...meta } =
    useCustomDropzone(dropOptions);

  const [isHovered, setIsHovered] = useState(false);

  const dropzoneMeta = {
    ...meta,
    isHovered,
  };

  const rootProps = getRootProps({
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  });

  return (
    <div
      {...rootProps}
      className={classNames(
        className,
        // asDefault ? undefined : theme[color || worldColor].base,
        'rounded-lg border border-primary-100 overflow-hidden',
        {
          'cursor-not-allowed !opacity-50': dropOptions?.disabled,
          [` cursor-pointer`]: !dropOptions?.disabled,
        },
      )}
      onClick={onClick ? onClick : (rootProps as any).onClick}
    >
      <input {...getInputProps()} />

      <div
        className={classNames(
          'h-full flex flex-col justify-center items-center py-6 px-3',
          renderWrapperClassName,
        )}
      >
        {render(dropzoneMeta)}
      </div>
    </div>
  );
};

export default Dropzone;
